import React from "react";
import PropTypes from "prop-types";
import tw, { styled } from "twin.macro";

const Container = tw.div`flex flex-col space-y-2`;
const TocLink = styled("a")(({ level }) => [
  tw`text-sm text-blue-700 hocus:text-blue-900 leading-tight`,
  level == 1 ? tw`` : level == 2 ? tw`ml-4` : tw`ml-8`
]);

const Toc = ({ headings }) => {
  return (
    <Container>
      {headings &&
        headings.map(heading => (
          <TocLink
            level={heading.depth}
            href={`#${heading.id}`}
            key={heading.id}
          >
            {heading.level} {heading.value}
          </TocLink>
        ))}
    </Container>
  );
};

Toc.propTypes = {
  headings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
      depth: PropTypes.number
    })
  )
};

export default Toc;
